import React from 'react';
import { Eye, Edit, Key, Mail, Phone, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const EnseignantActionButtons = ({ 
  enseignant, 
  onEdit, 
  onDelete,
  onCreateAccount 
}) => {
  const navigate = useNavigate();

  // Vérifier directement si l'enseignant a un compte utilisateur
  // La relation est stockée dans enseignant.utilisateur
  const hasAccount = enseignant.utilisateur !== null && enseignant.utilisateur !== undefined;
  
  // Debug: afficher les informations de l'enseignant
  console.log('Enseignant:', enseignant.nom, enseignant.prenom, 'Utilisateur:', enseignant.utilisateur, 'HasAccount:', hasAccount);

  return (
    <div className="flex justify-end space-x-2">
      <button
        onClick={() => navigate(`/enseignant/${enseignant.id}`)}
        className="text-indigo-600 hover:text-indigo-900"
        title="Voir les détails"
      >
        <Eye className="h-5 w-5" />
      </button>
      
      <button
        onClick={() => onEdit(enseignant)}
        className="text-blue-600 hover:text-blue-900"
        title="Modifier"
      >
        <Edit className="h-5 w-5" />
      </button>
      
      {/* Bouton de création de compte - masqué si l'enseignant en a déjà un */}
      {!hasAccount && (
        <button
          onClick={() => onCreateAccount(enseignant)}
          className="text-green-600 hover:text-green-900"
          title="Créer un compte"
        >
          <Key className="h-5 w-5" />
        </button>
      )}
      
      {/* Indicateur si l'enseignant a déjà un compte */}
      {hasAccount && (
        <div className="text-green-600" title="Compte utilisateur déjà créé">
          <Key className="h-5 w-5 opacity-50" />
        </div>
      )}
      
      {enseignant.email && (
        <a
          href={`mailto:${enseignant.email}`}
          className="text-green-600 hover:text-green-900"
          title="Envoyer un email"
        >
          <Mail className="h-5 w-5" />
        </a>
      )}
      
      {enseignant.telephone && (
        <a
          href={`tel:${enseignant.telephone}`}
          className="text-blue-600 hover:text-blue-900"
          title="Appeler"
        >
          <Phone className="h-5 w-5" />
        </a>
      )}

      <button
        onClick={() => onDelete(enseignant)}
        className="text-red-600 hover:text-red-900"
        title="Supprimer"
      >
        <Trash2 className="h-5 w-5" />
      </button>
    </div>
  );
};

export default EnseignantActionButtons;
